<ng-container *ngIf="{ products: products$ | async } as content">
    <div class="col-12">
       <h2 class="main-title" >Buy it Again</h2>
    </div>

    <p-carousel role="region"
                [value]="content.products"
                [numVisible]="4"
                [numScroll]="4"
                [circular]="true"
                [autoplayInterval]="5000"
                [classList]="'custom-carousel'"
                [responsiveOptions]="responsiveOptions">
      <ng-template pTemplate="item" let-item>
        <div class="custom-item">
          <product-card [product]="item" [lazyPrice]="true"></product-card>
        </div>
      </ng-template>
    </p-carousel>
</ng-container>
